<template>
    <v-dialog v-model="dialogData.dialog" content-class="confirmation-dialog" >
        <div class="confirmation-container">
            <h4 class="--font text-center"> {{ dialogData.content }} </h4>
            <div class="flex mt-5 space-between">
                <button class="--green --weight" style="background: #F5F9F5;" v-ripple @click="closeDialog">No</button>
                <button class="--weight white--text" style="background: #338A37;" v-ripple @click="confirm">Yes</button>
            </div>
        </div>
    </v-dialog>
</template>

<script>
export default {
    name : "confirmationDialog",

    computed : {
        dialogData() {
            return this.$store.getters['mainStore/GET_CONFIRMATION_DIALOG'];
        }
    },

    methods : {
        closeDialog() {
            this.$store.commit("mainStore/CLOSE_CONFIRMATION_DIALOG");
        },

        confirm() {
            this.dialogData.action();
            this.closeDialog();
        }
    }
}
</script>

<style lang="scss" scoped>

.confirmation-container {
    padding: 20px;
}

h4 {
    font-weight: 500;
}

button {
    width: 49%;
    padding: 12px 0;
    border-radius: 5px;
}

</style>

<style lang="scss">

.confirmation-dialog.v-dialog {
	width: 30%;
    background-color: white;
}
</style>